import { all } from "redux-saga/effects";
import { xetKhoaLuanSaga } from "./xetKhoaLuanSaga";
export function* xetKhoaLuanSagaWrapper(): any {
    yield all([
        xetKhoaLuanSaga(),
    ]);
}